export default __webpack_public_path__ + "static/media/escudo.5d53e091.svg";